import React, { useMemo, useEffect } from "react";
import { Box, Typography } from "@mui/material";

const FloorPlanViewer = ({ floorDetails }) => {
  const floorplanUrl = useMemo(() => {
    if (!floorDetails?.svgFile) return null;
    const blob = new Blob([floorDetails.svgFile], { type: "image/svg+xml" });
    return URL.createObjectURL(blob);
  }, [floorDetails?.svgFile]);

  useEffect(() => {
    return () => {
      if (floorplanUrl) URL.revokeObjectURL(floorplanUrl);
    };
  }, [floorplanUrl]);

  if (!floorDetails?.svgFile) {
    return (
      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          bgcolor: "#fafafa",
          border: "2px dashed #ccc",
          borderRadius: "8px",
          p: 3,
        }}
      >
        <Typography
          variant="h6"
          sx={{ color: "#555", textAlign: "center", fontWeight: 500, lineHeight: 1.5 }}
        >
          There is no design plan for this floor.
          <br />
          Please update it.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ width: "100%", height: "100%", overflow: "hidden" }}>
      <img
        src={floorplanUrl}
        alt="Floor Plan"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "contain",   // ✅ always fits, never crops
          display: "block",
        }}
      />
    </Box>
  );
};

export default FloorPlanViewer;